export const submitHelpWidgetMessageBody = (subject, msg, email, image) => () => {
  let sendHelpWidgetMessage = `${encodeURIComponent('subject')}=${encodeURIComponent(subject)}`
  sendHelpWidgetMessage += `&${encodeURIComponent('msg')}=${encodeURIComponent(msg)}`
  sendHelpWidgetMessage += `&${encodeURIComponent('email')}=${encodeURIComponent(email)}`
  sendHelpWidgetMessage += `&${encodeURIComponent('image[image]')}=${encodeURIComponent(image)}`
  return sendHelpWidgetMessage
}
